import _ from 'lodash';

import { DEFAULT_ATTRIBUTE } from '../constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'state' implicitly has an 'any' type.
const getNextVehicle = (state) => {
  const { vehicles, dynamicFilters } = state;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'DEFAULT_ATTRIBUTE' is possibly 'undefined'.
  const lastFilter = _.find(dynamicFilters, ({ label }) => label === DEFAULT_ATTRIBUTE.name);
  const selectedOption = _.get(lastFilter, 'selectedOption');
  return _.find(vehicles, ({ redbookCode }) => redbookCode === selectedOption.id);
};

export default getNextVehicle;
